import React from 'react';

const PageNotFound = () => <div>Page not found!</div>;

export default PageNotFound;
